import { Map } from 'immutable';
import actions from 'redux/constants/admin/services';

const defaultState = () => new Map({
  serviceItem: new Map(),
  serviceIsSubmitting: false,
  serviceCreateFailed: false,
})

export default (state = defaultState(), action) => {
  switch(action.type) {
    case actions.SET_SERVICE_DETAIL_ADMIN:
      return state.set('serviceDetail', action.data)
    case actions.SERVICE_IS_SUBMITTING:
      return state.set('serviceIsSubmitting', action.data)
    case actions.SERVICE_SUBMIT_FAILED:
      return state.set('serviceSubmitFailed', action.data)
    case actions.LOAD_SERVICES_ADMIN:
      return state.set('servicesList', action.data)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/admin/services.js